import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Autocomplete from '@mui/material/Autocomplete';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import BlockIcon from "@mui/icons-material/Block";
import ClearIcon from "@mui/icons-material/Clear";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Slider from "@mui/material/Slider";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { AnnotationIcon } from "../../components/icons/icons";
import DateTimePicker from '@mui/lab/DateTimePicker';
import Formatter from "../../util/formatter";
import config from "../../app/config";
import _ from "lodash";
import moment from "moment";
import Thumbnail from "../patient/thumbnail";
import { docTypes, specialties } from "../../store/reducers/dicts";
import Grid from "@mui/material/Grid";
import { ListboxComponent } from "./penItemUtil";
import MessageBox from "../../util/messageBox";
import API from "../../app/api";
import ViewDocument from "../viewer/viewDocument";
import {setGlobalVariable, setSnackbar} from '../../store/reducers/globals';
import {Checkbox, FormGroup, InputLabel, MenuItem, Select} from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';
import ListSubheader from '@mui/material/ListSubheader';
import {hasPermission, Permissions} from '../../store/reducers/user';
import {getSelectedDocuments} from '../../store/reducers/documents';
import PrintIcon from '@mui/icons-material/Print';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import useOpenState from '../../hooks/useOpenState';
import * as mime from 'react-native-mime-types';
import * as contentDisposition from 'content-disposition-header';
import {globalImageCache} from '../viewer/imageCache';
export const CustomAutocomplete = withStyles((theme) => ({
    input: {
        color: theme.palette.tb.color.main,
        fontSize: "90%",
        fontWeight: 300,
        padding: "3px !important",
        paddingLeft: 10
    },
    listbox: {
        fontSize: "90%",
        fontWeight: 300,
    },
}))(Autocomplete);

// noinspection JSSuspiciousNameCombination
const useStyles = makeStyles((theme) => ({
    penItemMain: {
        backgroundColor: "#202020",
        border: "1px solid #151515",
        boxShadow: theme.shadows[2],
        margin: "10px 0",
        lineHeight: 0,
    },
    popper: {
      zIndex: 9999
    },
    penItemThumb: {
        display: "inline-block",
        width: config.modules.thumbnail.size.pen.width,
        height: config.modules.thumbnail.size.pen.height,
        maxHeight: config.modules.thumbnail.size.pen.width,
        maxWidth: config.modules.thumbnail.size.pen.height,
    },
    penItemBody: {
        display: "inline-block",
        height: config.modules.thumbnail.size.pen.height,
        maxHeight: config.modules.thumbnail.size.pen.height,
        width: config.modules.thumbnail.size.pen.widthHelper,
        maxWidth: config.modules.thumbnail.size.pen.widthHelper,
        verticalAlign: "top",
        lineHeight: "normal",
        // padding: 10,
    },
    formItem: {
        padding: "10px 5px",
    },
    selectInput: {
        // display: "flex",
        // justifyContent: "space-between",
        // alignItems: "center",
    },
    tablePropName: {
        textAlign: "right",
        fontWeight: "bold",
        padding: 5,
    },
    tablePropValue: {
        fontWeight: 300,
        padding: 5,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        // color: '#fff',
    },
    buttonOverlay: {
        display: "inline-block",
    },
    modalMain: {
        outline: "none",
        // padding: 100,
        userSelect: "none",
        // position: 'absolute',
        // width: 400,
        // backgroundColor: theme.palette.background.paper,
        // border: '2px solid #000',
        // boxShadow: theme.shadows[5],
        // padding: theme.spacing(2, 4, 3),
    },
    modalBackground: {
        overflow: "hidden",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        backgroundColor: "rgba(0,0,0,.75)",
    },
    modalToolbar: {
        height: 48,
        padding: "10px 25vw",
    },
    modalContentView: {
        height: "calc(100vh - 96px)",
    },
    modalFooter: {
        height: 48,
        textAlign: "center",
        padding: "10px 0",
    },
    menuPaper: {
        maxHeight: 300
    }
}));

export function PenItemEyonix(props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const history = useHistory();
    const dispatch = useDispatch();
    const userCanDelete = dispatch(hasPermission(Permissions.CAN_DELETE_DOC_HP));
    const userUploadDelete = dispatch(hasPermission(Permissions.CAN_UPLOAD_DOCUMENT));
    const canModifyDocument = dispatch(hasPermission(Permissions.CAN_MODIFY_PATIENT_RECORD));
    const [message, setMessage] = React.useState(null);
    const [canDelete, setCanDelete] = React.useState(false);
    const [messageTitle, setMessageTitle] = React.useState(t("Information"));

    const [loading, setLoading] = React.useState(false);

    const [tabValue, setTabValue] = React.useState(0);
    const [patientData, setPatientData] = React.useState(null);
    const [documentLocal, setDocumentLocal] = React.useState(null);
    const [modifiedFlag, setModifiedFlag] = React.useState(false);

    const [showDocumentModal, setShowDocumentModal] = React.useState(false);

    const defaultScale = window.innerWidth - (window.innerWidth * 0.4);
    // const [documentVewStyle, setDocumentVewStyle] = React.useState({});
    const [documentVewZoom, setDocumentVewZoom] = React.useState(defaultScale);
    const [documentSelected, setDocumentSelected] = React.useState(null);
    const docTypesDict = useSelector(docTypes);

    const canPrintAndDownloadDocument = dispatch(hasPermission(Permissions.CAN_PRINT_AND_DOWNLOAD));
    const [docSelected, setDocSelected] = useState(false);
    const anchorRefDownload = React.useRef(null);
    const [isDownloadDropDownOpen, openDownloadDropDown, closeDownloadDropDown] = useOpenState(false, true);

    const resetDocument = () => {
        const documentCopy = _.cloneDeep(props.document);

        // we need to find speciality by code ...
        documentCopy._meta = {
            documentDate: moment(documentCopy.startDate),
            docType: documentCopy.docType,
            patientId: documentCopy.metadata.patientId,
            operatorName: documentCopy.metadata.operatorName,
            location: documentCopy.metadata.location,
            laterality: documentCopy.metadata.laterality,
            studyId: documentCopy.metadata.studyId,
            patientDob: documentCopy.metadata.patientDob? moment(documentCopy.metadata.patientDob, "YYYYMMDD"): null
        };

        // console.log("_meta", documentCopy._meta);
        // documentCopy.metadata.tab_id = "LG38955-7";

        //setDocSelected(false);
        setDocumentLocal(documentCopy);
    };

    const selectedDocumentsFromPatient = useSelector(getSelectedDocuments);

    useEffect(()=>{
        setDocSelected(selectedDocumentsFromPatient?.some((id) => {return id === props.document?.__id}))
    },[selectedDocumentsFromPatient])

    useEffect(()=>{
        if(docSelected && !_.isEmpty(props.dataToEdit)) {
            setDocumentLocal((document) => {
                return {
                    ...document,
                    _meta: {
                        ...document._meta,
                        ...props.dataToEdit
                    }

                }

            })
           //saveDocumentChanges()
             setModifiedFlag(true);
        }

    },[props.dataToEdit]);

    useEffect(() => {
            resetDocument();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.document]);

    const imgSize = config.modules.thumbnail.size["pen"].loadWidth;
    const [imgURL, setImgURL] = React.useState(`${config.apiUrl}/patients/${config.modules.holdingPen.name}/documents/${props.document.__id}/pages/1/preview/lo/image?size=${imgSize}&Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`);
    // let imgURL = `${config.apiUrl}/patients/${config.modules.holdingPen.name}/documents/${props.document.__id}/pages/1/thumbnail/image?size=${imgSize}&Authorization=${window.keycloak.token}`;
    // if (document.__haveLoadError) {
    //     imgURL = "/image/error.png";
    // }

    const confirmDelete = () => {
        // D9010020 - test
        setCanDelete(false);

        API.deleteDocument(documentLocal.__id, null, documentLocal.metadata.emailMsgId).then(response => {
            if (response.success) {
                if (props.onDelete) {
                    props.onDelete(documentLocal);
                }
            } else {
                setMessageTitle(t("Error while trying to delete document"));
                setMessage(t("Document cant be delete right now. Please try again in a moment"));
            }

        }).catch((error)=>{
            setMessageTitle(t("Error while trying to delete document"));
            setMessage(t("Document cant be delete right now. Please try again in a moment"));
        });
    };

    const annotateDocument = () => {
        if(canModifyDocument) {
            globalImageCache.clean();

            let documentsInfo = {
                mode: "split", // split || tabs || holding
                documents: [documentLocal.__id],
            };
            documentsInfo = JSON.stringify(documentsInfo);
            documentsInfo = btoa(documentsInfo);

            const patientId = config.modules.holdingPen.name;
            history.push(`/view/${patientId}/${documentsInfo}`);
        }
    }

    const deleteDocument = () => {
        if(userCanDelete) setCanDelete(true);
    };

    const acceptDocument = () => {
        if (
            (!documentLocal._meta.patientId && !documentLocal._meta.gref) ||
            ((documentLocal._meta.patientId && documentLocal._meta.patientId.trim().length === 0) &&
                (documentLocal._meta.gref && documentLocal._meta.gref.trim().length === 0))
        ) {
            setMessageTitle(t("Patient id not found"));
            setMessage(t("Providing patient number or genetic reference is required."));
        } else {
            if (!documentLocal._meta.documentDate) {
                setMessageTitle(t("Document date required"));
                setMessage(t("Providing document date is required!"));
            } else {
                const updatedPatientId = (documentLocal._meta.patientId && documentLocal._meta.patientId.trim().length > 0) ?
                    documentLocal._meta.patientId : documentLocal._meta.gref;

                API.getPatientByID(documentLocal._meta.patientId).then(patient => {
                    if (!patient) {
                        setMessageTitle(t("Patient not found"));
                        setMessage(t("Entered patient number is not found in database. Document can't be accepted."));
                    } else if(patient && patient.dob && patientDobIsVisible() && (documentLocal._meta.patientDob === null || !moment(patient.dob).isSame(documentLocal._meta.patientDob, "date"))) {
                        setPatientData(patient);
                        setMessageTitle(t("Patient dob"));
                        setMessage(t("Entered patient dob is not correct. Document can't be accepted."));
                    } else {
                        API.moveDocument(documentLocal.__id, updatedPatientId, documentLocal.metadata.emailMsgId).then(response => {
                            if (response.success) {
                                // setSnackMessage(t("Document accepted"));
                                if (props.onAccept) {
                                    props.onAccept(documentLocal);
                                }
                            } else {
                                setMessageTitle(t("Error while trying to accept document"));
                                setMessage(t("Document cant be accepted right now. Please try again in a short moment"));
                            }
                        });
                    }

                }).catch(function (error) {
                    // TODO: error handler !!!
                    console.error(error);

                    setMessageTitle(t("Error"));
                    setMessage(t("Error during accepting patient record. Please try later!"));
                });

            }
        }
    };

    const saveDocumentChanges = () => {
        if (
            !documentLocal._meta.patientId || documentLocal._meta.patientId.trim().length === 0
        ) {
            setMessageTitle(t("Patient id not found"));
            setMessage(t("Providing patient number is required."));
        } else {
            if (!documentLocal._meta.documentDate) {
                setMessageTitle(t("Document date required"));
                setMessage(t("Providing document date is required!"));
            } else {
                // console.log("documentLocal._meta", documentLocal._meta);
                API.updateDocumentData({
                    documentDate: documentLocal._meta.documentDate ? documentLocal._meta.documentDate.toISOString() : null,
                    docType: documentLocal._meta.docType ? documentLocal._meta.docType.__id : null,
                    "metadata": {
                        operatorName: documentLocal._meta.operatorName ? documentLocal._meta.operatorName : null,
                        patientId: documentLocal._meta.patientId ? documentLocal._meta.patientId : null,
                        location: documentLocal._meta.location ? documentLocal._meta.location : null,
                        laterality: documentLocal._meta.laterality ? documentLocal._meta.laterality : null,
                        study: documentLocal._meta.studyId ? documentLocal._meta.studyId : null,
                        patientDob: documentLocal._meta.patientDob ? documentLocal._meta.patientDob.format("YYYYMMDD") : null,
                    },
                }, documentLocal.__id).then(response => {
                    if (response === true) {
                        dispatch(setSnackbar({type: "success", message: t("Document data saved correctly")}));
                        setModifiedFlag(false);
                        API.getDocument(documentLocal.__id, config.modules.holdingPen.name).then(document => {
                            if (props.onChange) {
                                props.onChange(document);
                            }
                        });
                    } else {
                        setMessageTitle(t("Error while trying to save data"));
                        setMessage(t("Data cant be saved right now. Please try again in a short moment"));
                    }
                });
            }
        }
    };

    const cancelDocumentChanges = () => {
        resetDocument();
        setModifiedFlag(false);
    };

    const checkPatient = (checkPatientBeforePrint = false) => {
        if (patientData && documentLocal._meta.patientId === patientData.hospitalNumber) {
            if(!checkPatientBeforePrint) setTabValue(1);
        } else {
            // loading
            setLoading(true);
            API.getPatientByID(documentLocal._meta.patientId).then(patient => {
                if (!patient) {
                    setMessageTitle(t("Patient not found"));
                    if(!checkPatientBeforePrint) {
                        setMessage(t("Entered patient number is not found in database. " +
                            "System will allow to accept anyway and when patient data will be added document will appear in patient record correctly."));
                    } else {
                        setMessage(t("Patient number is not found in database. "))
                    }

                } else {
                    dispatch(setSnackbar({type: "success", message: t("Patient data loaded")}));
                    setPatientData(patient);
                    if(!checkPatientBeforePrint) setTabValue(1);
                }

                if(checkPatientBeforePrint) printPfdDocument(patient);

                setLoading(false);
            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);

                if(!checkPatientBeforePrint) {
                    setMessageTitle(t("Error"));
                    setMessage(t("Error during check. Please try later!"));
                } else {
                    printPfdDocument(null)
                }

                setLoading(false);
            });
        }
    };

    const fireDocumentChangeEvent = (document) => {
        if (props.onChange) {
            const documentClone = _.cloneDeep(document);
            delete documentClone._meta;
            props.onChange(documentClone);
        }
    };

    const openDocument = (document) => () => {
        // console.log("open", document);
        // API.getMetadataForDocuments(patientId, [document.__id]).then(metadata => {
        //     console.warn("metadata", metadata);
        // });
        setDocumentVewZoom(defaultScale);
        setDocumentSelected(document);
        setShowDocumentModal(true);
    };

    const changeDocType = (event, newValue) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.docType = newValue;
        setDocumentLocal(newDocumentLocal);
        // fireDocumentChangeEvent(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changeDocumentDate = (newValue) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.documentDate = newValue;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changeDocumentPatientDob = (newValue) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.patientDob = newValue;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changePatientNumber = (event) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.patientId = event.target.value;
        setDocumentLocal(newDocumentLocal);
        // setLoadedPatientNULL
        setPatientData(null);
        setModifiedFlag(true);
    };
    const changeOperatorName = (event) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.operatorName = event.target.value;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changeStudyId = (event) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.studyId = event.target.value;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changeLocation = (event) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.location = event.target.value;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };
    const changeLaterality = (event) => {
        const newDocumentLocal = _.cloneDeep(documentLocal);
        newDocumentLocal._meta.laterality = event.target.value;
        setDocumentLocal(newDocumentLocal);
        setModifiedFlag(true);
    };

    // for LWH required will be:
    // 1. DocType
    // 2. Patient number or gREF
    // 3. Document date
    //

    const handleZoomChange = (event, zoom) => {
        setDocumentVewZoom(zoom);
    };

    // const marks = [
    //     {
    //         value: defaultScale,
    //         label: "default",
    //     },
    // ];

    const clearGlobalVariable = () => {
        const variableName = "toolbarViewer" + 1;
        dispatch(setGlobalVariable({
            name: variableName,
            value: null,
        }));
    }

    const hideDocumentModal = () => {
        clearGlobalVariable()
        setShowDocumentModal(false);
    }

    const handleSelectDocToMove = (e) => {
        if(props.onSelect) props.onSelect(e.target.checked, documentLocal);
        setDocSelected(e.target.checked);
    }

    useEffect(()=>{
        if(modifiedFlag) {
            if(props.onSelect) props.onSelect(false, documentLocal);
            setDocSelected(false);
        }
    },[modifiedFlag])

    const patientDobIsVisible = () => {
        if(config?.holdingPenTypesForDob) {
            if(config.holdingPenTypesForDob.all?.find((type) => type === documentLocal._meta.docType?.name)) {
                return true
            }
            let setForModality = Object.keys(config?.holdingPenTypesForDob)?.find((locations) => locations === documentLocal._meta?.location);

            if(setForModality && config?.holdingPenTypesForDob[setForModality]?.find((type) => type === documentLocal._meta.docType?.name)) {
                return true
            }
        }

        return false;
    }


    const handleToggle = () => {
        isDownloadDropDownOpen? closeDownloadDropDown(): openDownloadDropDown()
    };

    const downloadSelectedDocuments = () => {
        API.downloadDocument(props.document.__id, {nameType: "filename"}).then(response => {
            let type = mime.extension(response.data.type);
            let fileName = props.document.__id
            if(type) {
                fileName += "." + type;
            }

            const cd = response.request.getResponseHeader("Content-Disposition");
            if (cd) {
                const cdParsed = contentDisposition.parse(cd);
                if (cdParsed.parameters.filename) {
                    fileName = cdParsed.parameters.filename;
                }
            }

            if(response.data.type === "application/dicom") {
                fileName += ".dcm";
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

        });
    }

    const printPfdDocument = (patientData, type) => {
        let printUrl = config.printUrl;

        if (printUrl) {
            let data = {
                contentDisposition: type,
                type: "doc",
                noWatermark: true,
                patient: {
                    patientId: patientData?.hospitalNumber || props.document.metadata.patientId || "-",
                    nhsNumber: patientData?.nhsNumber || "-",
                    firstName: patientData?.firstName || "-",
                    middleName: patientData?.middleName || "-",
                    familyName: patientData?.familyName || "-",
                    title: patientData?.title || "-",
                    dob: moment(patientData?.dob)?.format("DD/MM/YYYY") || "-",
                    gender: patientData?.gender || "-",
                    addressLine1: patientData?.addressLines[0] || "-",
                    addressLine2: patientData?.addressLines[1] || "-",
                    addressLine3: patientData?.addressLines[2] || "-",
                    addressLine4: patientData?.addressLines[3] || "-",
                    postCode: patientData?.postCode || "-",
                    homeTelephone: patientData?.homeTelephone || "-",
                    workTelephone: patientData?.workTelephone || "-",
                    mobileTelephone: patientData?.mobileTelephone || "-",
                    email: patientData?.emailAddress || "-",
                },
                tabs: []
            };

            data.tabs.push({
                name: `Document - ${props.document.docType?.name ? props.document.docType?.name : props.document.metadata?.procedureName}`,
                documents: [{
                    id: props.document.__id,
                    startDate: moment(props.document.startDate).format("DD/MM/YYYY HH:mm"),
                    dateSort: moment(props.document.startDate).format("DD/MM/YYYY HH:mm"),
                    type: (props.document.docType?.name || "no type"),
                    pages: props.document.pageCount
                }]
            })

            var dataJSON = JSON.stringify(data);

            var form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', printUrl);
            form.setAttribute("target", "_blank");

            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", "data");
            hiddenField.setAttribute("value", dataJSON);
            form.appendChild(hiddenField);

            var hiddenFieldAuth = document.createElement("input");
            hiddenFieldAuth.setAttribute("type", "hidden");
            hiddenFieldAuth.setAttribute("name", "Authorization");
            hiddenFieldAuth.setAttribute("value", `Bearer ${window.keycloak?.token ? window.keycloak?.token : window.auth?.token}`);
            form.appendChild(hiddenFieldAuth);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    }

    const downloadSelectedPDFDocuments = (type) => {
        if(patientData || !documentLocal._meta.patientId) {
            printPfdDocument(patientData, type)
        } else {
            checkPatient(true)
        }
    }


    const printImageWithAnnotations = () => {
        const URL = `${config.apiUrl}/patients/${config.modules.holdingPen.name}/documents/${props.document.__id}/pages/1/preview/hi/image?Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;

        const w = window.open('', '');
        w.document.write(`<html><head> <title>HoldingPen - ${props.document.metadata.patientId? props.document.metadata.patientId: "-"}</title>`);
        w.document.write('</head><body >');
        w.document.write('<img id="print-image-element" width="100%" src="'+URL+'"/>');
        w.document.write('<script>var img = document.getElementById("print-image-element"); img.addEventListener("load",function(){ window.focus(); window.print(); window.document.close(); window.close(); }); </script>');
        w.document.write('</body></html>');
    }

    return (
        <div className={classes.penItemMain}>
            <Popper className={classes.popper} open={isDownloadDropDownOpen}
                    placement="bottom-start"
                    anchorEl={anchorRefDownload.current} role={undefined} transition
                    >
                {({TransitionProps, placement}) => (
                    <Grow {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={closeDownloadDropDown}>
                                <div>
                                    <MenuList>
                                        <MenuItem
                                            className={classes.listElement}
                                            onClick={downloadSelectedDocuments}
                                        >
                                            Download Original File
                                        </MenuItem>
                                        <MenuItem
                                            className={classes.listElement}
                                            onClick={()=>downloadSelectedPDFDocuments("attachment")}
                                        >
                                            Download as a Report
                                        </MenuItem>
                                        <MenuItem
                                            className={classes.listElement}
                                            onClick={()=>downloadSelectedPDFDocuments("inline")}
                                        >
                                            Open as a Report
                                        </MenuItem>
                                        <MenuItem
                                            className={classes.listElement}
                                            onClick={printImageWithAnnotations}
                                        >
                                            Print
                                        </MenuItem>
                                    </MenuList>
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <Modal open={showDocumentModal}>
                <div className={classes.modalMain}>
                    <div className={classes.modalBackground} onClick={hideDocumentModal}>
                    </div>
                    <div className={classes.modalToolbar}>
                        <Grid container spacing={2}>
                            <Grid item>
                                <ZoomInIcon />
                            </Grid>
                            <Grid item xs>
                                <Slider
                                    step={window.innerWidth * .05}
                                    // marks={marks}
                                    marks
                                    value={documentVewZoom}
                                    min={window.innerWidth / 4}
                                    max={window.innerWidth * 2}
                                    onChange={handleZoomChange} />
                            </Grid>
                            <Grid item>
                                <ZoomOutIcon />
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.modalContentView}>
                        <ViewDocument
                            viewerId={1}
                            onClickBack={hideDocumentModal}
                            patientId={config.modules.holdingPen.name}
                            zoom={documentVewZoom}
                            document={documentSelected} />
                    </div>
                    <div className={classes.modalFooter}>
                        <Button variant="outlined" size="small" color="primary" onClick={hideDocumentModal}>
                            {t("Close preview")}
                        </Button>
                    </div>
                </div>
            </Modal>
            <Backdrop open={loading} className={classes.backdrop}>
                <CircularProgress />
            </Backdrop>
            <MessageBox onClose={() => {
                setMessage(null);
                setMessageTitle(t("Information"));
            }} title={messageTitle} message={message} open={!!message} />
            <MessageBox
                onClose={() => {
                    setCanDelete(false);
                }}
                title={t("Confirmation")}
                haveAccept={{ yes: t("Accept"), no: t("Cancel") }}
                onAccept={confirmDelete}
                message={t("Are you sure you want to decline the document? It will be permanently deleted and not recoverable.")}
                open={!!canDelete} />

            <div className={classes.penItemThumb}>
                {documentLocal &&
                    <Thumbnail key={documentLocal.__id} document={documentLocal}
                               hideLabel={true}
                               onOpenDocument={openDocument(documentLocal)}
                               onImageLoadError={() => {
                                   setImgURL("/image/error.png");
                               }}
                               imageUrl={imgURL} size={"pen"} />
                }
            </div>
            <div className={classes.penItemBody}>
                <AppBar position="static" color="default" style={{position: "relative"}}>
                    <Tabs value={tabValue}
                          textColor={"inherit"}
                          indicatorColor={props.viewMode? "secondary": "primary"}
                          style={{background: props.viewMode? (props.isError? "#70191C": "#2180F7") : "unset"}}
                          onChange={(e, nv) => setTabValue(nv)}>
                        <Tab label={t("data")} />
                        {/*
                        <Tab disabled={!patientData} label={t("patient details") +
                        (patientData ? ": " + patientData.firstName + " " + patientData.familyName : "")}/>
                        */}
                    {/*{!patientData && <Tab disabled={!patientData} label={t("patient details")}/>}*/}
                    {patientData && <Tab disabled={!patientData} label={patientData.firstName + " " + patientData.familyName}/>}
                </Tabs>
                <div style={{position: "absolute", right: 0, top: 5}}>
                    <FormGroup>
                        <FormControlLabel
                            sx={{flex: "center"}}
                            name={"checked"}
                            control={
                                <Checkbox
                                    checked={(props.viewMode || docSelected)}
                                    disabled={(modifiedFlag || props.bulkActionActive)}
                                    color={props.viewMode? "info": "secondary"}
                                    onChange={handleSelectDocToMove}/>
                            }
                            label={t("")}/>
                    </FormGroup>
                </div>
            </AppBar>

            {documentLocal && tabValue === 0 &&
            <div style={{padding: 10}}>
                <div style={{margin: "10px 0 5px", width: "100%"}}>
                    {/*<TextField style={{width: "90%"}} label="Maybe something?" value={"study id ___"}/>*/}
                    <Grid container columns={13}>
                        <Grid item xs={3}>
                            <div className={classes.formItem}>
                                <DateTimePicker
                                    // className={classes.formControlDT}
                                    invalidDateMessage={null}
                                    autoOk
                                    clearable={true}
                                    disableToolbar
                                    inputFormat={config.defaultDateTimeFormat}
                                    ampm={false}
                                    disabled={(props.viewMode || docSelected)}
                                    margin="normal"
                                    label={t("Document date")}
                                    emptyLabel={t("no date selected")}
                                    value={props.metaDataToUpdate?.startDate || documentLocal._meta.documentDate}
                                    onChange={changeDocumentDate}
                                    style={{width: "100%", margin: 0}}
                                    inputVariant="outlined"
                                    renderInput={(inp) => <TextField className={"custom-dt"} {...inp} size="small"/>}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={5}>
                            <div className={classes.formItem}>
                                {/*PATIENT NUM*/}
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    variant="outlined"
                                    className={"custom-dt"}
                                    placeholder={t("enter patient number")}
                                    style={{width: "100%"}} label={t("Patient number")}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title={t("Check Patient number")}>
                                                    <IconButton
                                                        onClick={() => checkPatient(false)}
                                                        size="small"
                                                        disabled={!(props.metaDataToUpdate?.patientId || documentLocal._meta.patientId)}
                                                    >
                                                        <CheckIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                    disabled={(props.viewMode || docSelected)}
                                    onChange={changePatientNumber}
                                    value={props.metaDataToUpdate?.patientId || documentLocal._meta.patientId}/>
                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className={classes.formItem}>
                                <DatePicker
                                    invalidDateMessage={null}
                                    autoOk
                                    clearable={true}
                                    disableToolbar
                                    inputFormat={config.defaultDateFormat}
                                    ampm={false}
                                    disabled={(props.viewMode || docSelected)}
                                    margin="normal"
                                    label={t("Patient dob")}
                                    emptyLabel={t("no date selected")}
                                    value={props.metaDataToUpdate?.patientDob ||documentLocal._meta.patientDob || null}
                                    onChange={changeDocumentPatientDob}
                                    inputVariant="outlined"
                                    renderInput={(inp) => <TextField style={{width: "100%", margin: 0}}
                                                                     className={"custom-dt"} {...inp} size="small"/>}
                                />
                            </div>

                        </Grid>

                        <Grid item xs={3}>
                            <div className={classes.formItem}>
                                {docTypesDict &&
                                <CustomAutocomplete
                                    ListboxComponent={ListboxComponent}
                                    disableListWrap
                                    size="small"
                                    // autoSelect={true}
                                    options={docTypesDict}
                                    disabled={(props.viewMode || docSelected)}
                                    getOptionLabel={(option) => option && option.name ? option.name : ""}
                                    style={{width: "100%"}}
                                    value={props.metaDataToUpdate?.docType || documentLocal._meta.docType}
                                    onChange={changeDocType}
                                    getOptionSelected={(option, value) => option.__id === value.__id}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            size="small"
                                            label={t("Document type")}
                                            placeholder={t("select doctype")}
                                            variant="outlined"/>}
                                />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className={classes.formItem}>
                                {/*
                                            Technician Name,
                                            MRN, OD/OS/OU (Radio button to select),
                                            Procedure name (DocType), [rather the final name like OCT .... something?]
                                            Location) -> Eyonix
                                        */}
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    variant="outlined"
                                    disabled={(props.viewMode || docSelected)}
                                    className={"custom-dt"}
                                    placeholder={t("enter study id")}
                                    style={{width: "100%"}} label={t("Study id")}
                                    onChange={changeStudyId}
                                    value={props.metaDataToUpdate?.studyId || documentLocal._meta.studyId || ""}/>
                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className={classes.formItem}>
                                {/*
                                            Technician Name,
                                            MRN, OD/OS/OU (Radio button to select),
                                            Procedure name (DocType), [rather the final name like OCT .... something?]
                                            Location) -> Eyonix
                                        */}
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    variant="outlined"
                                    disabled={(props.viewMode || docSelected)}
                                    className={"custom-dt"}
                                    placeholder={t("enter technician name")}
                                    style={{width: "100%"}} label={t("Technician name")}
                                    onChange={changeOperatorName}
                                    value={props.metaDataToUpdate?.operatorName || documentLocal._meta.operatorName || ""}/>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.formItem}>
                                <FormControl fullWidth size={"small"}>
                                    <InputLabel shrink htmlFor="grouped-native-select">Location</InputLabel>
                                    <Select onChange={changeLocation}
                                            size={"small"}
                                            notched
                                            renderValue={(val) => val}
                                            disabled={(props.viewMode || docSelected)}
                                            value={props.metaDataToUpdate?.location || documentLocal._meta.location || ""}
                                            MenuProps={{classes: {paper: classes.menuPaper}}}
                                            id="grouped-native-select" label="Location">
                                        <ListSubheader>Custom</ListSubheader>
                                        <MenuItem value={"Web"}>
                                            Web
                                        </MenuItem>
                                        {/*{documentLocal._meta.location &&*/}
                                        {/*    <MenuItem value={documentLocal._meta.location}>*/}
                                        {/*        <em>{documentLocal._meta.location}</em>*/}
                                        {/*    </MenuItem>*/}
                                        {/*}*/}

                                        {props.locationDict && Object.keys(props.locationDict).map((key) => {
                                            let items = [<ListSubheader>{key}</ListSubheader>];
                                            props.locationDict[key].forEach((item) => {
                                                items.push(<MenuItem
                                                    value={key + " " + item.__code}>{item.__code}</MenuItem>)
                                            })

                                            return items;
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={classes.formItem} style={{marginLeft: 20}}>
                                <RadioGroup row name="laterality" value={props.metaDataToUpdate?.laterality || documentLocal._meta.laterality}
                                            onChange={changeLaterality}>
                                    <FormControlLabel
                                        value={null}
                                        control={<Radio
                                            disabled={(props.viewMode || docSelected)}
                                            color="secondary"/>}
                                        label={t("Unset")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="R" control={<Radio disabled={(props.viewMode || docSelected)} color="primary"/>}
                                        label={t("OD")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="L" control={<Radio disabled={(props.viewMode || docSelected)} color="primary"/>}
                                        label={t("OS")} labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="B" control={<Radio disabled={(props.viewMode || docSelected)} color="primary"/>}
                                        label={t("OU")} labelPlacement="end"
                                    />
                                </RadioGroup>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                {(!props.viewMode && !docSelected) && <div style={{textAlign: "right", marginRight: 5, marginTop: -60}}>
                        <div className={classes.buttonOverlay}>
                            <IconButton
                                variant="outlined"
                                disabled={(!canPrintAndDownloadDocument || modifiedFlag)}
                                onClick={handleToggle}
                                ref={anchorRefDownload}
                                size="large">
                                <PrintIcon/>
                            </IconButton>
                        </div>

                    <Tooltip title={t("Save modified document")}>
                        <div className={classes.buttonOverlay}>
                            <IconButton
                                variant="outlined"
                                disabled={!modifiedFlag}
                                onClick={saveDocumentChanges}
                                size="large">
                                <SaveIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Cancel changes")}>
                        <div className={classes.buttonOverlay}>
                            <IconButton disabled={!modifiedFlag} onClick={cancelDocumentChanges} size="large">
                                <ClearIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Accept document and insert into repository")}>
                        <div className={classes.buttonOverlay}>
                            <IconButton disabled={modifiedFlag || !userUploadDelete} onClick={acceptDocument}
                                        size="large">
                                <DoneAllIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Decline and remove document")}>
                        <div className={classes.buttonOverlay} onClick={deleteDocument}>
                            <IconButton size="large" disabled={!userCanDelete}>
                                <BlockIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Annotate document")}>
                        <div className={classes.buttonOverlay} onClick={annotateDocument}>
                            <IconButton color={"primary"} size="large" disabled={!canModifyDocument}>
                                <AnnotationIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                </div>
                }
            </div>
            }

            {documentLocal && tabValue === 1 &&
            <div style={{padding: "15px 10px 10px 10px"}}>
                <Grid container>
                    <Grid item xs={12}>
                        <table>
                            <tbody>
                            <tr>
                                <td className={classes.tablePropName}>Number:</td>
                                <td className={classes.tablePropValue}>{patientData.hospitalNumber}</td>
                            </tr>
                            <tr>
                                <td className={classes.tablePropName}>Name:</td>
                                <td className={classes.tablePropValue}>{patientData.firstName}</td>
                            </tr>
                            <tr>
                                <td className={classes.tablePropName}>Surname:</td>
                                <td className={classes.tablePropValue}>{patientData.familyName}</td>
                            </tr>
                            <tr>
                                <td className={classes.tablePropName}>Gender:</td>
                                <td className={classes.tablePropValue}>{patientData.gender}</td>
                            </tr>
                            <tr>
                                <td className={classes.tablePropName}>DOB:</td>
                                <td className={classes.tablePropValue}>{Formatter.formatBirthDate(patientData.dob)}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Grid>
                </Grid>
            </div>
            }
        </div>
    </div>
    );
}
